import { render, staticRenderFns } from "./_banks.vue?vue&type=template&id=ba46d232&scoped=true&"
import script from "./_banks.vue?vue&type=script&lang=js&"
export * from "./_banks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba46d232",
  null
  
)

export default component.exports